export default "__VITE_ASSET__CLPtlbKv__"